import { ComponentPropsWithRef } from "react";
import { staticText } from "../../shared/statics/static-text";

// TEXT
export const text = staticText.authButtons;

// STYLES

// DATA

// TYPES
export type Props = {
  onEmailButtonClick?: () => void;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
export const GoogleIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.06 12.25C23.06 11.47 22.99 10.72 22.86 10H12.5V14.26H18.42C18.16 15.63 17.38 16.79 16.21 17.57V20.34H19.78C21.86 18.42 23.06 15.6 23.06 12.25Z"
      fill="#4285F4"
    />
    <path
      d="M12.4997 23.0001C15.4697 23.0001 17.9597 22.0201 19.7797 20.3401L16.2097 17.5701C15.2297 18.2301 13.9797 18.6301 12.4997 18.6301C9.63969 18.6301 7.20969 16.7001 6.33969 14.1001H2.67969V16.9401C4.48969 20.5301 8.19969 23.0001 12.4997 23.0001Z"
      fill="#34A853"
    />
    <path
      d="M6.34 14.0898C6.12 13.4298 5.99 12.7298 5.99 11.9998C5.99 11.2698 6.12 10.5698 6.34 9.90982V7.06982H2.68C1.93 8.54982 1.5 10.2198 1.5 11.9998C1.5 13.7798 1.93 15.4498 2.68 16.9298L5.53 14.7098L6.34 14.0898Z"
      fill="#FBBC05"
    />
    <path
      d="M12.4997 5.38C14.1197 5.38 15.5597 5.94 16.7097 7.02L19.8597 3.87C17.9497 2.09 15.4697 1 12.4997 1C8.19969 1 4.48969 3.47 2.67969 7.07L6.33969 9.91C7.20969 7.31 9.63969 5.38 12.4997 5.38Z"
      fill="#EA4335"
    />
  </svg>
);

export const MicrosoftIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="10.5766" height="10.5768" fill="#F25022" />
    <rect
      x="12.4229"
      y="0.999969"
      width="10.5766"
      height="10.5768"
      fill="#7FBA00"
    />
    <rect x="1" y="12.4232" width="10.5766" height="10.5768" fill="#00A4EF" />
    <rect
      x="12.4229"
      y="12.4232"
      width="10.5766"
      height="10.5768"
      fill="#FFB900"
    />
  </svg>
);
